'use client';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import styles from './DangerZoneCard.module.css';

interface DangerZoneCardProps {
	onDelete: () => void;
	isLoading?: boolean;
}

export const DangerZoneCard = ({ onDelete, isLoading }: DangerZoneCardProps) => {
	return (
		<div className={styles.card}>
			<button className={styles.dangerButton} onClick={onDelete} disabled={isLoading} type="button">
				<div className={styles.buttonContent}>
					<div className={styles.iconWrapper}>
						<DeleteOutlineIcon className={styles.icon} />
					</div>
					<div className={styles.buttonText}>
						<span className={styles.buttonLabel}>Excluir Conta</span>
						<span className={styles.buttonDescription}>Remover permanentemente seus dados</span>
					</div>
				</div>
				<ChevronRightIcon className={styles.chevron} />
			</button>
		</div>
	);
};
